import { observer } from 'mobx-react-lite';
import { View } from 'react-native';
import { style } from './DrawerPhotoDrawer.style';
import TextLato from '../text/text-lato/TextLato';
import { useStore } from 'src/contexts/StoreContext';
import { ICON_NAMES } from '../icon/icon.helper';
import { TestIDs } from 'src/constants/testIDs.constants';
import { drawerTestID } from 'src/helpers/testIDs.helper';
import { FocusGroups } from '../focus-provider/FocusProvider.constants';
import { CircularButton } from '../buttons/circular-button/CircularButton';
import { CIRCULAR_BUTTON_SIZES, CIRCULAR_BUTTON_TYPES } from '../buttons/circular-button/CircularButton.constants';
import { DrawerPhotoPicker } from './drawer-photo-picker/DrawerPhotoPicker';

export const DrawerPhotoDrawer = observer(() => {
  const { i18n, drawer, project } = useStore();

  return (
    <>
      <View style={style.wrapper}>
        <View style={style.topBar}>
          <TextLato style={style.title}>{i18n.t('photo-drawer:your-photos')}</TextLato>
          <CircularButton
            size={CIRCULAR_BUTTON_SIZES.SMALL}
            type={CIRCULAR_BUTTON_TYPES.ONLY_ICON}
            testID={drawerTestID(TestIDs.CLOSE)}
            focusId={drawerTestID(TestIDs.CLOSE)}
            focusGroup={FocusGroups.MODAL}
            focusOrder={0}
            iconName={ICON_NAMES.Close}
            iconStyle={style.iconClose}
            onPress={async () => {
              drawer.closeDrawerManual();
              project.activeProject?.deselectAllThumbnailImages();
            }}
          />
        </View>

        <DrawerPhotoPicker />
      </View>
    </>
  );
});

DrawerPhotoDrawer.displayName = 'DrawerPhotoDrawer';
